import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    server: {},
    modes: [],
    recommendDvrServers: [],
    reserveDvrServers: [],
    reserveTransfers: [],
    loading: false,
  },
  actions,
  mutations,
};
